/**
 * 클립보드 쓰기는 보안 컨텍스트(https/localhost) + 사용자 제스처 안에서만 허용된다 —
 * 그 밖의 환경·권한 거부는 예외 대신 false 로 돌려 호출자가 피드백만 갈라 쓰게 한다.
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  const clipboard = globalThis.navigator?.clipboard;
  if (!clipboard?.writeText) return false;
  try {
    await clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
